"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeLocaleConfig = void 0;
const updateLocale_1 = __importDefault(require("dayjs/plugin/updateLocale"));
const initializeLocaleConfig = (dayjs) => {
    dayjs.extend(updateLocale_1.default);
    dayjs.updateLocale('de', {
        calendar: {
            sameDay: '[Heute]',
            nextDay: '[Morgen]',
            nextWeek: 'ddd DD.MM',
            lastDay: '[Gestern]',
            lastWeek: '[Letzten] dddd',
            sameElse: 'ddd DD.MM'
        }
    });
    dayjs.updateLocale('en', {
        calendar: {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'ddd DD.MM',
            lastDay: '[Yesterday]',
            lastWeek: '[Last] dddd',
            sameElse: 'ddd DD.MM'
        }
    });
};
exports.initializeLocaleConfig = initializeLocaleConfig;
